import { palette } from '@livable/saas-react-components';
const MuiAutocomplete = {
  styleOverrides: {
    root: {
      '& .MuiOutlinedInput-root': {
        padding: '0'
      }
    },
    popper: {
      boxShadow: palette.shadows.hard
    },
    listbox: {
      '& .MuiAutocomplete-option': {
        padding: '12px 20px',
        fontSize: '18px',
        lineHeight: '24px',
        '&:hover': {
          backgroundColor: palette.shades[300],
          '.MuiCheckbox-root': {
            color: palette.shades[800]
          }
        },
        '&.Mui-selected': {
          backgroundColor: palette.primary.main,
          color: palette.shades[100],
          '&:hover': {
            backgroundColor: palette.primary.dark
          }
        },
        '&.Mui-focusVisible': {
          backgroundColor: palette.shades[300],
          '&:hover': {
            backgroundColor: palette.shades[300]
          },
          '&.Mui-selected': {
            backgroundColor: palette.primary.dark
          }
        }
      }
    },
    noOptions: {
      padding: '12px 20px',
      color: palette.shades[700]
    }
  },
  variants: [{
    props: {
      variant: 'withIcon'
    },
    style: {
      '& .MuiOutlinedInput-root .MuiAutocomplete-input': {
        padding: '12px 12px 12px 40px'
      }
    }
  }, {
    props: {
      variant: 'plain'
    },
    style: {
      '& .MuiInputLabel-root': {
        transform: 'translate(12px, 16px) scale(1)'
      },
      '& .MuiOutlinedInput-root': {
        paddingTop: '6px',
        paddingBottom: '6px',
        alignItems: 'baseline'
      },
      '& .MuiOutlinedInput-root .MuiAutocomplete-input': {
        padding: '10px 12px'
      },
      '& .MuiAutocomplete-popupIndicator path': {
        fill: palette.shades[700]
      },
      '& .MuiAutocomplete-clearIndicator path': {
        fill: palette.shades[700]
      },
      '& .MuiAutocomplete-tag': {
        margin: '0',
        borderRadius: '2px',
        height: '32px',
        padding: '6px 6px 6px 10px',
        backgroundColor: palette.shades[200],
        border: "1px solid ".concat(palette.shades[300]),
        fontSize: '18px',
        lineHeight: '24px',
        fontWeight: '400',
        marginRight: '4px',
        marginTop: '6px',
        marginBottom: '0',
        fontFamily: palette.fontFamilies.source,
        '& + .MuiAutocomplete-tag': {
          marginLeft: '0'
        },
        '& .MuiSvgIcon-root': {
          margin: '0',
          fontSize: '20px',
          marginLeft: '4px',
          '& path': {
            fill: palette.shades[700]
          },
          '&:hover path': {
            fill: palette.shades[800]
          }
        },
        '&:last-child': {
          marginBottom: '12px'
        }
      }
    }
  }]
};
export default MuiAutocomplete;